(function () {
  'use strict';

  function initFigure(figure) {
    const data = figure.querySelector('[data-pcm-design-features]');
    let features;
    if (data) {
      try {
        features = JSON.parse(data.textContent);
      } catch (_) {
        return;
      }
      if (!Array.isArray(features)) return;
    } else {
      features = Array.from(document.querySelectorAll('.pcm-feature-grid-numbered-large__item'), (feature) => ({
        title: feature.querySelector('.pcm-feature-grid-numbered-large__card-title')?.textContent.trim(),
        description: feature.querySelector('.pcm-feature-grid-numbered-large__description')?.textContent.trim(),
      }));
    }
    const tooltips = new Map();
    let active = null;
    let closeTimer;

    function close() {
      clearTimeout(closeTimer);
      if (!active) return;
      tooltips.get(active).hide();
      active.classList.remove('is-active');
      active = null;
    }

    function open(button) {
      clearTimeout(closeTimer);
      if (active === button) return;
      close();
      active = button;
      button.classList.add('is-active');
      tooltips.get(button).show();
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      if (active?.matches(':focus-visible')) return;
      closeTimer = setTimeout(() => {
        if (!active || active.matches(':hover, :focus-visible')) return;
        const tip = document.getElementById(active.getAttribute('aria-describedby'));
        if (!tip?.matches(':hover')) close();
      }, 140);
    }

    figure.querySelectorAll('[data-pcm-design-hotspot]').forEach((button) => {
      const index = Number(button.dataset.pcmDesignHotspot);
      const title = String(features[index]?.title ?? '').trim();
      const description = String(features[index]?.description ?? '').trim();
      if (!title) return;

      // Both page layouts use the same saved design-elements wording.
      const content = document.createElement('div');
      const heading = document.createElement('strong');
      heading.textContent = `${index + 1}. ${title}`;
      content.append(heading);
      if (description) {
        const body = document.createElement('div');
        body.textContent = description;
        content.append(body);
      }
      button.setAttribute('aria-label', `${index + 1}. ${title}`);
      button.hidden = false;
      tooltips.set(button, new bootstrap.Tooltip(button, {
        title: content,
        html: true,
        trigger: 'manual',
        container: 'body',
        placement: 'top',
        customClass: 'pcm-design-elements-tooltip',
        animation: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        popperConfig: (config) => ({
          ...config,
          modifiers: config.modifiers.map((modifier) => modifier.name === 'preventOverflow'
            ? { ...modifier, options: { ...modifier.options, padding: 16, rootBoundary: 'viewport' } }
            : modifier),
        }),
      }));

      button.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') open(button);
      });
      button.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') scheduleClose();
      });
      button.addEventListener('focus', () => {
        if (button.matches(':focus-visible')) open(button);
      });
      button.addEventListener('blur', scheduleClose);
      button.addEventListener('click', () => {
        if (active === button && window.matchMedia('(hover: none)').matches) close();
        else open(button);
      });
      button.addEventListener('inserted.bs.tooltip', () => {
        const tip = document.getElementById(button.getAttribute('aria-describedby'));
        tip?.addEventListener('pointerenter', () => clearTimeout(closeTimer));
        tip?.addEventListener('pointerleave', scheduleClose);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
    document.addEventListener('pointerdown', (event) => {
      if (!event.target.closest('[data-pcm-design-hotspot], .pcm-design-elements-tooltip')) close();
    });
  }

  function init() {
    if (!window.bootstrap?.Tooltip) return;
    document.querySelectorAll('[data-pcm-design-elements]').forEach(initFigure);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
